import { createAction, props } from '@ngrx/store';

import { Association, AssociationFilter } from '@shared/models';
import { Pagination } from '@shared/pagination';
import { AssociationParams } from '@shared/services/association.service';

export const associationsGetList = createAction(
  '[Associations] Get List',
  props<{ jobId: number; candidateIds?: number[]; hiringManagerAction?: boolean }>(),
);

export const associationsGetListSuccess = createAction(
  '[Associations] Get List Success',
  props<{ associations?: Association[] }>(),
);

export const associationsGetListFailure = createAction(
  '[Associations] Get List Failure',
  props<{ error?: any }>(),
);

export const associationsLoadSelectedCandidateOnAssignsContainerPageChange = createAction(
  '[Associations] [CandidateAssignsContainerComponent.pageChange] Load Associations for Selected Candidate',
  props<{ currentFilter?: AssociationFilter }>(),
);

export const associationUpdateFilterEffect = createAction(
  '[Associations] [AssignsEffects.associationUpdateFilterEffect$] Load Associations for Selected Candidate',
  props<{ params?: Partial<AssociationParams> }>(),
);

export const loadAssociationsForCandidateOnAssignToJobComponent = createAction(
  '[Associations] [AssignToJobComponent] Load Associations for Candidate',
  props<{ candidateId: number }>(),
);

export const associationsLoadSuccess = createAction(
  '[Associations] Load Success',
  props<{ associationPage: Pagination<Association> }>(),
);

export const associationsLoadFailure = createAction(
  '[Associations] Load Failure',
  props<{ error?: any }>(),
);

export const associationsPatch = createAction(
  '[Associations] Patch',
  props<{ association?: Partial<Association> }>(),
);

export const associationsPatchSuccess = createAction(
  '[Associations] Patch Success',
  props<{ association?: Association }>(),
);

export const associationsPatchFailure = createAction(
  '[Associations] Patch Failure',
  props<{ error?: any }>(),
);

export const associationRemove = createAction(
  '[Associations] Remove Association',
  props<{ id: number }>(),
);

export const patchSelectedCandidateAssociationFilterEffect = createAction(
  '[Associations] [AssignsEffects.patchSelectedCandidateAssociationFilter$] Patch Association Filter',
  props<{ id: string; filter?: AssociationFilter; assigned?: boolean }>(),
);

export const associationManySuccessEffectPatchAssociationFilter = createAction(
  '[Associations] [AssignsEffects.associationManySuccess$] Patch Association Filter',
  props<{ id: string; filter?: AssociationFilter }>(),
);

export const loadAssociationsForSelectedCandidateEffectPatchAssociationFilter = createAction(
  '[Associations] [CandidatesEffects.loadAssociationsForSelectedCandidate$] Patch Association Filter',
  props<{ id: string; filter?: AssociationFilter }>(),
);

export const associationsSuccessEffectLoadPatchAssociationFilter = createAction(
  '[Associations] [AssignsEffects.associationSuccess$] Patch Association Filter',
  props<{ id: string; filter?: AssociationFilter }>(),
);

export const collectionAssociationsClear = createAction('[Associations] Clear Associations');
